<template>
  <div>
    <div v-if="items && items.length > 0" class="listado d-none d-md-block">
      <b-table
        ref="instituciones"
        :fields="camposTabla"
        :items="items"
        :current-page="currentPage"
        :per-page="perPage"
        @row-selected="onRowSelected"
        select-mode="single"
        selectable
        class="table table-hover table-sm"
      >
        <template v-slot:cell(institucion)="data">
          <span
            @click="onRowSelected"
            class="text-negro"
            v-b-tooltip.hover
            :title="data.value.nombre"
            >{{ data.value.nombreCorto }}</span
          >
        </template>
        <template v-slot:cell(acreditacion)="data">
          <!--<div v-if="data.value.acreditado">
            <span>{{textoLateral(data.value)}}</span>
          </div>
          <div v-else-if="data.value.acreditacionCNA">Bajo Tutela</div>
          <div v-else>No Acreditado</div>-->
          <div>
            <span>{{ data.value }}</span>
          </div>
        </template>
        <!--<template v-slot:cell(gratuidad)="data">
          <Gratuidad :gratuidad="data.value" :tooltipDisabled="true" />
        </template>-->
        <template v-slot:cell(web)="data">
          <a :href="data.value" target="_blank">Ver Sitio web</a>
        </template>
        <template v-slot:cell(contacto)="data">
          <!--<input type="checkbox" aria-label="Checkbox_contacto" />-->
          <span
            @click="onRowSelected(data.value)"
            v-b-tooltip.hover
            title="Solicita que te envíen más información sobre esta institución"
          >
            <FontAwesomeIcon icon="envelope" />
          </span>
        </template>
      </b-table>

      <b-pagination
        v-if="items && items.length > 0"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        class="col-md-4 mx-auto px-0"
        align="center"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import Gratuidad from "@/components/generales/iconos/Gratuidad";
import AñosAcreditacion from "@/components/generales/iconos/AniosAcreditacion";
import Busqueda from "@/utils/Busqueda.js";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faServer, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { ModalContactoTP } from "@/utils/BusesDeEventos.js";
library.add(faServer, faEnvelope);
export default {
  name: "VistaTabla",
  props: {
    listadoInstituciones: {
      type: Array
    }
  },
  components: {
    Gratuidad,
    AñosAcreditacion,
    FontAwesomeIcon
  },
  data() {
    return {
      datos: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 8,
      verFicha: true,
      camposTabla: [
        {
          key: "region",
          label: "Región",
          sortable: true,
          tdClass: "text-left"
        },
        {
          key: "institucion",
          label: "Institución",
          sortable: true,
          tdClass: "text-left"
        },
        {
          key: "acreditacion",
          label: "Acreditación",
          sortable: true,
          tdClass: "text-nowrap"
        },
        { key: "beneficios", label: "Beneficios del Estado", sortable: true },
        { key: "web", label: "Sitio web" },
        { key: "contacto", label: "Contáctame" }
      ]
    };
  },
  watch: {
    listadoInstituciones() {
      this.totalRows = this.listadoInstituciones.length;
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.listadoInstituciones.length;
  },
  computed: {
    items() {
      let items = [];
      let li = this.listadoInstituciones;
      for (let ins of li) {
        items.push({
          id: ins.id,
          region: this.limpiarNombreRegion(ins.region),
          institucion: {
            nombreCorto: ins.nombreCorto,
            nombre: ins.nombre
          },
          acreditacion: this.textoAcreditacion(
            ins.acreditado,
            ins.acreditacion.anios,
            ins.observacionAcreditacionCNA
          ),
          beneficios: ins.beneficiosEstatales,
          web: ins.web,
          contacto: {
            modal: true,
            codigoIntitucion: ins.codigo,
            codigoSede:
              ins.listadoSedes.length === 1
                ? ins.listadoSedes[0].codigoSede
                : null,
            listadoSedes: ins.listadoSedes.length > 1 ? ins.listadoSedes : null
          }
        });
      }
      return items;
    }
  },
  methods: {
    textoLateral(data) {
      let text = data === 1 ? "año" : "años";
      return ` ${data} ${text}`;
    },
    textoAcreditacion(acreditado, anios, observacionCNA) {
      let text = "";
      if (acreditado) {
        if (anios === 0) {
          text = "Acreditado";
        } else {
          text = this.textoLateral(anios);
        }
      } else if (observacionCNA) {
        text = "Bajo Tutela";
      } else {
        text = "No Acreditado";
      }
      return text;
    },
    limpiarNombreRegion(region) {
      return Busqueda.limpiarNombreRegionSimble(region);
    },
    arregloInstitucionesPaginado(arreglo) {
      this.datos = arreglo;
    },
    onRowSelected(value) {
      if (value.modal) {
        this.verFicha = false;
        ModalContactoTP.$emit("contactameTP", value);
      } else if (this.verFicha && value[0]) {
        let idInst = value[0].id;
        this.$router.push({
          name: "FichaInstitucion",
          params: { idInstitucion: idInst, origen: "BuscadorIP" }
        });
      } else {
        this.verFicha = true;
        this.$refs.instituciones.clearSelected();
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/buscadorIP/VistaTabla.vue